export const CUSTOM_COLOR_PICKER_MODAL_ID = 'customColorPicker';
